export class Pelicula {

  public id: number;
  public titulo: string;
  public subtitulo: string;
  public texto: string;
  public imagen_horizontal: string;
  public imagen_vertical: string;
  public duracion: string;
  public categoria: string;
  public destacado: boolean;
  public cartelera: boolean;
  constructor() { }
}
